
import { reactive, ref,inject} from 'vue'
import goodsList from '@/components/goods/goods-list.vue'
import headline from '@/components/headline/headline.vue'

export default {
    components:{
        goodsList,
        headline
    },
  setup(){
    const list:any = reactive([])
    const loading = ref(false)
    const finished = ref(false)
    const product = reactive({
        size:10,
        page:1,
        total :500,      
        list:[],
        is_login:false
    })
    const $store: any = inject('$store');
    const $http: any = inject('$http')

      const store_datas = $store.getHomeRecommentDatas();
      if(store_datas && store_datas.page && store_datas.list) {
        product.page = store_datas.page
        product.list = store_datas.list
      }
      const onLoad = async ()=>{         
       const res =  await $http.recommend({
               size:product.size,
               page:product.page,
               total:product.total,
                type:'1',
           },product.is_login)
           if(res.code === 200  && res.data.products){
             product.list = product.list.concat(res.data.products)
             product.page = product.page + 1  
             loading.value = false
            if(product.list.length>=res.meta.total){
                  finished.value = true
            }  
            $store.setHomeRecommentDatas(product)                  
           }else {         
                finished.value = true
           }         
      }
       return {
        product,
        loading,
        finished,
        onLoad,
    }
  }
}
